<template>
  <div class="pratice-communication-and-marketing-content" id="identidade-verbal-na-pratica-perfil" data-search-anchor>
        <h1 class="pratice-communication-and-marketing-title">
          {{ praticeCommunicationAndMarketingTitle }}
        </h1>      

        <div class="pratice-colums-communication-and-marketing-wrapper">
            <div class="pratice-communication-and-marketing-container">
                <p class="pratice-profile-paragraph-title">{{ praticeProfileParagraphTitle }}</p>
                <p class="pratice-profile-paragraph">{{ praticeProfileParagraph1 }}</p>                        
                <p class="pratice-profile-paragraph">{{ praticeProfileParagraph2 }}</p>                
                <p class="pratice-profile-paragraph">{{ praticeProfileParagraph3 }}</p>
                <p class="pratice-profile-paragraph">{{ praticeProfileParagraph4 }}</p>            
            </div>

            <div class="pratice-communication-and-marketing-tips-container">
                <p class="pratice-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-cm-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <ThreeCircles />
                <p class="pratice-tips-cm-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <ThreeCircles />
                <p class="pratice-tips-cm-paragraph">{{ praticeTipsParagraph5 }}</p>
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph6 }}</p>
                <ThreeCircles />

                <div class="pratice-tips-legend-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph7 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph8 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeCommunicationAndMarketingSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticeCommunicationAndMarketingTitle(): string {
    return this.getElementTitle(2, 0)
  }

  get praticeProfileParagraphTitle(): string {
    return this.getElementText(2, 0)
  }

  get praticeProfileParagraph1(): string {
    return this.getElementText(2, 1)
  }

  get praticeProfileParagraph2(): string {
    return this.getElementText(2, 2)
  }

  get praticeProfileParagraph3(): string {
    return this.getElementText(2, 3)
  }

  get praticeProfileParagraph4(): string {
    return this.getElementText(2, 4)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(2, 5)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(2, 6)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(2, 7)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(2, 8)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(2, 9)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(2, 10)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(2, 11)
  }

  get praticeTipsParagraph7(): string {
    return this.getElementText(2, 12)
  }

  get praticeTipsParagraph8(): string {
    return this.getElementText(2, 13)
  }

  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-communication-and-marketing-content {
  display: grid;
  justify-content: center;
  margin-top: 100px;  
  max-width: 1032px;
}

.pratice-communication-and-marketing-title {
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
  text-align: left;
  margin: 0;
  width: 100%;
}

.pratice-colums-communication-and-marketing-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 495px);
  gap: 42px;
  margin-top: 50px;
}

.pratice-communication-and-marketing-container {
  width: 506px;
  height: 735px;
  border-radius: 16px;  
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
}

.pratice-communication-and-marketing-tips-container {
  width: 506px;
  height: 735px;
}

.pratice-profile-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
  white-space: pre;
}

.pratice-profile-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
}

.pratice-profile-paragraph-title {
  white-space: pre;
}

.pratice-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 48px;
  white-space: pre;  
}

.pratice-tips-cm-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre;
  color: rgba(149, 149, 149, 1); 
}

.pratice-tips-cm-paragraph:nth-child(5) {
  margin-top: 52px;
}

.pratice-tips-cm-paragraph:nth-child(8) {
  margin-top: 74px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  margin: 0;
}

.pratice-tips-legend-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 66px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
